// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { ActionButton, Checkbox, DefaultButton, IconButton, PrimaryButton } from "@fluentui/react";
import { strings } from "../../../../common/strings";
import {
    ITableRegion,
    ITableTag,
    ITag,
    ITagForDelete,
    TagInputMode,
    ILabel
} from "../../../../models/applicationState";
import { constants } from "../../../../common/constants";
import { getStorageItem } from "../../../../redux/middleware/localStorage";
import { getPrimaryGreyTheme } from "../../../../common/themes";
import "./tagInputToolbar.scss";

enum Categories {
    General,
    Separator,
    RenameModifier,
    MoveModifier,
    DeleteModifier,
    SelectAll,
    Save
}

/** Properties for tag input toolbar */
export interface ITagInputToolbarProps {
    /** Currently selected tag */
    selectedTag: ITag;
    /** Function to call when add tags button is clicked */
    onAddTags: () => void;
    onUploadTags: () => void;
    downloadToExcel: (withTables: boolean) => void;

    setTagInputMode?: (
        tagInputMode: TagInputMode,
        selectedTableTagToLabel?: ITableTag,
        selectedTableTagBody?: ITableRegion[][][]
    ) => void;
    /** Function to call when search tags button is clicked */
    onSearchTags: () => void;
    /** Function to call when lock tags button is clicked */
    onLockTag: (tag: ITag) => void;
    /** Function to call when edit tag button is clicked */
    onRenameTag: (tag: ITag) => void;
    /** Function to call when delete button is clicked */
    onDelete: (tag: ITag) => void;
    onDeleteSeletedTags: (tagLabelMap: Map<string, ILabel[]>) => void;
    /** Function to call when one of the re-order buttons is clicked */
    onReorder: (tag: ITag, displacement: number) => void;
    onOnlyCurrentPageTags: (onlyCurrentPageTags: boolean) => void;
    onShowOriginLabels?: (showOrigin: boolean) => void;
    searchingTags: boolean;
    selectedTags?: ITag[];
    tags?: ITag[];
    onDeleteCheckedChanged?: (tag: ITag) => void;
    selectAllTagsForDeleteOnClick?: (check: boolean) => void;
    selectAllForDelete: boolean;
    TagLabelMap: Map<string, ILabel[]>;
    widgetMode?: boolean;
}

interface ITagInputToolbarItemProps {
    displayName: string;
    icon?: string;
    category?: Categories;
    handler?: () => void;
    accelerators?: string[];    
}

interface ITagInputToolbarItemState {
    tagFilterToggled: boolean;
    showOriginLabels: boolean;
}

export default class TagInputToolbar extends React.Component<
    ITagInputToolbarProps,
    ITagInputToolbarItemState
> {
    state = {
        tagFilterToggled: false,
        showOriginLabels: constants.showOriginLabelsByDefault,
        selectAllForDelete: false,
    };

    public render() {
        return <div className="tag-input-toolbar">{this.renderItems()}</div>;
        // if (!this.props.widgetMode) {
        //     return <div className="tag-input-toolbar">{this.renderItems()}</div>;
        // }  
        // else {
        //     return null;
        // }      
        // else {
        //     return (
        //         <div className="tag-input-toolbar">
        //             <ActionButton iconProps={{iconName: 'Save'}} onClick={(e) => this.handleSave()} className="tag-input-toolbar-iconbuttonadhoc">
        //                 Save
        //             </ActionButton>
        //             <IconButton iconProps={{iconName: 'Save'}} onClick={(e) => this.handleSave()} className="tag-input-toolbar-iconbutton" />                    
        //         </div>
        //     )
        // }
    }
    // hachet
    private getToolbarItems = (): ITagInputToolbarItemProps[] => {
        return [
            // {
            //     displayName: "Select ALl",
            //     icon: "Upload",
            //     category: Categories.SelectAll,
            //     handler: this.selectAllOnClick,
            // },
            // {
            //     displayName: "Upload Tags",
            //     icon: "Upload",
            //     category: Categories.General,
            //     handler: this.handleUpload,
            // },
            // {
            //     displayName: "Export To Excel",
            //     icon: "Download",
            //     category: Categories.General,
            //     handler: this.downloadToExcel,
            // },
            // {
            //     displayName: "Export To Excel (without tables)",
            //     icon: "Build",
            //     category: Categories.General,
            //     handler: this.downloadToExcelWithoutTables,
            // },
            // {
            //     displayName: `${strings.tags.toolbar.vertiline}-3`,
            //     category: Categories.Separator,
            // },
            // {
            //     displayName: strings.tags.toolbar.add,
            //     icon: "Add",
            //     category: Categories.General,
            //     handler: this.handleAdd,
            // },
            // {
            //     displayName: strings.tags.toolbar.addTable,
            //     icon: "AddTable",
            //     category: Categories.General,
            //     handler: this.handleAddTable,
            // },
            // {
            //     displayName: `${strings.tags.toolbar.vertiline}-1`,
            //     category: Categories.Separator,
            // },
            // {
            //     displayName: this.state.tagFilterToggled
            //         ? strings.tags.toolbar.showAllTags
            //         : strings.tags.toolbar.onlyShowCurrentPageTags,
            //     icon: this.state.tagFilterToggled ? "ClearFilter" : "Filter",
            //     category: Categories.General,
            //     handler: this.handleOnlyCurrentPageTags,
            // },
            // {
            //     displayName: this.state.showOriginLabels
            //         ? strings.tags.toolbar.hideOriginLabels
            //         : strings.tags.toolbar.showOriginLabels,
            //     icon: this.state.showOriginLabels ? "GroupList" : "GroupedList",
            //     category: Categories.General,
            //     handler: this.handleShowOriginLabels,
            // },
            {
                displayName: strings.tags.toolbar.search,
                icon: "Filter",
                category: Categories.General,
                handler: this.handleSearch,
            },
            // {
            //     displayName: `${strings.tags.toolbar.vertiline}-2`,
            //     category: Categories.Separator,
            // },
            // {
            //     displayName: strings.tags.toolbar.rename,
            //     icon: "Rename",
            //     category: Categories.RenameModifier,
            //     handler: this.handleRename,
            // },
            // {
            //     displayName: strings.tags.toolbar.moveUp,
            //     icon: "Up",
            //     category: Categories.MoveModifier,
            //     handler: this.handleMoveUp,
            // },
            // {
            //     displayName: strings.tags.toolbar.moveDown,
            //     icon: "Down",
            //     category: Categories.MoveModifier,
            //     handler: this.handleMoveDown,
            // },
            // {
            //     displayName: `${strings.tags.toolbar.vertiline}-1`,
            //     category: Categories.Separator,
            // },
            // {
            //     displayName: strings.tags.toolbar.delete,
            //     icon: "Delete",
            //     category: Categories.DeleteModifier,
            //     handler: this.handleDelete,
            // },
        ];
    };

    private renderItems = () => {
        const moveModifierDisabled =
            !this.props.selectedTag || this.props.searchingTags;

        const hasChecked = this.props.tags.some((t: any) => t.checked === true);
        let deleteModifierDisabled = true;
        if (hasChecked) {
            deleteModifierDisabled = !hasChecked;
        }

        const allChecked = this.props.tags.filter(
            (x: any) => x.checked === true
        );
        const isCheckedAll = this.props.tags.length === allChecked.length;

        const renameModifierDisabled = !this.props.selectedTag;
        const moveModifierClassNames = ["tag-input-toolbar-iconbutton"];
        const checkAllModifierClassNames = ["tag-input-toolbar-iconbutton"];
        const renameModifierClassNames = ["tag-input-toolbar-iconbutton"];
        const deleteModifierClassNames = ["tag-input-toolbar-iconbutton"];
        if (moveModifierDisabled) {
            moveModifierClassNames.push(
                "tag-input-toolbar-iconbutton-disabled"
            );
        }
        if (renameModifierDisabled) {
            renameModifierClassNames.push(
                "tag-input-toolbar-iconbutton-disabled"
            );
        }

        if (deleteModifierDisabled) {
            deleteModifierClassNames.push(
                "tag-input-toolbar-iconbutton-disabled"
            );
        }

        const deleteModifierClassName = deleteModifierClassNames.join(" ");
        const moveModifierClassName = moveModifierClassNames.join(" ");
        const renameModifierClassName = renameModifierClassNames.join(" ");

        const self = this;

        return this.getToolbarItems().map((itemConfig, index) => {
            if (itemConfig.category === Categories.General) {
                return (
                    <IconButton
                        key={itemConfig.displayName}
                        title={itemConfig.displayName}
                        ariaLabel={itemConfig.displayName}
                        className="tag-input-toolbar-iconbutton"
                        iconProps={{ iconName: itemConfig.icon }}
                        autoFocus={!index}
                        onClick={(e) => this.onToolbarItemClick(e, itemConfig)}
                    />
                );
            } else if (itemConfig.category === Categories.Separator) {
                return (
                    <div
                        className="tag-input-toolbar-separator"
                        key={index}
                    ></div>
                );
            } else if (itemConfig.category === Categories.RenameModifier) {
                return (
                    <IconButton
                        key={itemConfig.displayName}
                        disabled={renameModifierDisabled}
                        title={itemConfig.displayName}
                        ariaLabel={itemConfig.displayName}
                        className={renameModifierClassName}
                        iconProps={{ iconName: itemConfig.icon }}
                        onClick={(e) => this.onToolbarItemClick(e, itemConfig)}
                    />
                );
            } else if (itemConfig.category === Categories.MoveModifier) {
                return (
                    <IconButton
                        key={itemConfig.displayName}
                        disabled={moveModifierDisabled}
                        title={itemConfig.displayName}
                        ariaLabel={itemConfig.displayName}
                        className={moveModifierClassName}
                        iconProps={{ iconName: itemConfig.icon }}
                        onClick={(e) => this.onToolbarItemClick(e, itemConfig)}
                    />
                );
            } else if (itemConfig.category === Categories.DeleteModifier) {
                return (
                    <IconButton
                        key={itemConfig.displayName}
                        disabled={deleteModifierDisabled}
                        title={itemConfig.displayName}
                        ariaLabel={itemConfig.displayName}
                        className={deleteModifierClassName}
                        iconProps={{ iconName: itemConfig.icon }}
                        onClick={(e) => this.onToolbarItemClick(e, itemConfig)}
                    />
                );
            } else if (itemConfig.category === Categories.SelectAll) {
                if (self.props.tags.length > 0) {
                    return (
                        <div className="select-all-container">
                            <Checkbox
                                title="Select All"
                                checked={isCheckedAll}
                                key="key_2131312"
                                className={checkAllModifierClassNames.join("")}
                                style={{ position: "absolute" }}
                                onChange={(e: any, value: boolean) => {
                                    this.props.selectAllTagsForDeleteOnClick(
                                        value
                                    );
                                }}
                                theme={getPrimaryGreyTheme()}
                            />
                        </div>
                    );
                } else {
                    return;
                }
            } else {
                throw new Error(
                    `Unsupported item category ${itemConfig.category}`
                );
            }
        });
    };

    private onToolbarItemClick = (
        e: any,
        itemConfig: ITagInputToolbarItemProps
    ): void => {
        e.stopPropagation();
        itemConfig.handler();
    };

    private handleAdd = () => {
        this.props.selectAllTagsForDeleteOnClick(false);
        this.props.onAddTags();
    };

    private handleUpload = () => {
        this.props.selectAllTagsForDeleteOnClick(false);
        this.props.onUploadTags();
    };

    private selectAllOnClick = () => {
        this.props.selectAllTagsForDeleteOnClick(false);
        this.props.onUploadTags();
    };

    private downloadToExcel = () => {
        this.props.selectAllTagsForDeleteOnClick(false);
        this.props.downloadToExcel(true);
    };

    private downloadToExcelWithoutTables = () => {
        this.props.selectAllTagsForDeleteOnClick(false);
        this.props.downloadToExcel(false);
    };

    private handleOnlyCurrentPageTags = () => {
        this.props.selectAllTagsForDeleteOnClick(false);
        this.setState(
            { tagFilterToggled: !this.state.tagFilterToggled },
            () => {
                this.props.onOnlyCurrentPageTags(this.state.tagFilterToggled);
            }
        );
    };

    private handleShowOriginLabels = () => {
        this.props.selectAllTagsForDeleteOnClick(false);
        this.setState(
            { showOriginLabels: !this.state.showOriginLabels },
            () => {
                if (this.props.onShowOriginLabels) {
                    this.props.onShowOriginLabels(this.state.showOriginLabels);
                }
            }
        );
    };

    private handleAddTable = () => {
        this.props.selectAllTagsForDeleteOnClick(false);
        this.props.setTagInputMode(TagInputMode.ConfigureTable, null, null);
    };

    private handleSearch = () => {
        this.props.onSearchTags();
        this.props.selectAllTagsForDeleteOnClick(false);
    };

    private handleRename = () => {
        if (this.props.selectedTag) {
            this.props.onRenameTag(this.props.selectedTag);
            this.props.selectAllTagsForDeleteOnClick(false);
        }
    };

    private handleMoveUp = () => {
        this.props.selectAllTagsForDeleteOnClick(false);
        if (this.props.selectedTag) {
            this.props.onReorder(this.props.selectedTag, -1);
        }
    };

    private handleMoveDown = () => {
        this.props.selectAllTagsForDeleteOnClick(false);
        if (this.props.selectedTag) {
            this.props.onReorder(this.props.selectedTag, 1);
        }
    };

    private handleDelete = () => {
        this.props.onDeleteSeletedTags(this.props.TagLabelMap);
    };
}
